import { useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft } from '@fortawesome/free-solid-svg-icons';

const QuoteToolbar = ({ quill }) => {
  const [showModal, setShowModal] = useState(false);
  const [quote, setQuote] = useState('');
  const [author, setAuthor] = useState('');
  const [source, setSource] = useState('');

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setQuote('');
    setAuthor('');
    setSource('');
  };

  const handleInsertQuote = () => {
    if (!quote.trim()) return;

    const quoteHtml = `
      <blockquote class="custom-quote">
        <p>${quote}</p>
        ${
          author
            ? `<footer>
          ${author}
          ${source ? `<cite>${source}</cite>` : ''}
        </footer>`
            : ''
        }
      </blockquote>
    `;

    const range = quill.getSelection(true);
    quill.insertText(range.index, '\n', 'user');
    quill.insertHtml(range.index + 1, quoteHtml);
    quill.insertText(range.index + 2, '\n', 'user');
    quill.setSelection(range.index + 3, 0);

    handleCloseModal();
  };

  return (
    <>
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={handleOpenModal}
        className="quote-toolbar-btn"
      >
        <FontAwesomeIcon icon={faQuoteLeft} className="me-1" />
        <span className="ms-1 d-none d-md-inline">Quote</span>
      </Button>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Insert Quote</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Quote Text</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={quote}
                onChange={(e) => setQuote(e.target.value)}
                placeholder="Enter the quote text"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Author (optional)</Form.Label>
              <Form.Control
                type="text"
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
                placeholder="Enter the author's name"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Source (optional)</Form.Label>
              <Form.Control
                type="text"
                value={source}
                onChange={(e) => setSource(e.target.value)}
                placeholder="Enter the source"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleInsertQuote}>
            Insert Quote
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default QuoteToolbar;
